export const tableCols = [
    { label: "Role", prop: "Role", type: "role", width: "", isFixed: false },
    { label: "Description", prop: "Description", type: "description", width: "", isFixed: false },
    { label: "Create time", prop: "createTime", type: "createtime", width: 200, isFixed: false },
    { label: "State", prop: "state", type: "Switch1", width: "", isFixed: false },
    {
        label: "Operation",
        type: "Button",
        width: 150,
        isFixed: "right",
        btnList: [
            {
                type: "",
                label: "Edit",
                handle: row => "edit"
            },
            {
                type: "",
                label: "Delete",
                handle: row => "delete"
            }
        ]
    }
]